import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

// API Service for AccountTypeMaster
export const accountTypeMasterService = createApi({
  reducerPath: "accountTypeMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["accountTypeMaster"],
  endpoints: (builder) => ({
    getAllAccountTypeMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.getAllAccountTypeMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getAllAccountTypeMasterBySearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.getAllAccountTypeMasterBySearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateAccountTypeMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.updateAccountTypeMaster}/${body.id}`,
          method: "PUT",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteAccountTypeMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.deleteAccountTypeMaster}/${body.id}`,
          method: "DELETE",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getAccountTypeMasterById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.getAccountTypeMasterById}/${body.id}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    saveAccountTypeMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.saveAccountTypeMaster}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    findAllAccountTypeMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.findAllAccountTypeMaster}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    bulkSaveAccountTypeMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.accountTypeMasterController.bulkSaveAccountTypeMaster}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useGetAllAccountTypeMasterMutation,
  useGetAllAccountTypeMasterBySearchMutation,
  useUpdateAccountTypeMasterMutation,
  useDeleteAccountTypeMasterMutation,
  useGetAccountTypeMasterByIdMutation,
  useSaveAccountTypeMasterMutation,
  useFindAllAccountTypeMasterMutation,
  useBulkSaveAccountTypeMasterMutation,
} = accountTypeMasterService;
